
<div *ngFor="let note of notes">
    <div class="d-flex align-items-center">
        <div class="ic-info-white"></div> 
        <div class="ml-3">
            <div >{{note.note}}</div>
        </div>
    </div>
    <div class="font-weight-normal notes-created-by">
        {{note.createdBy.name}}
    </div>
</div>